import axios from 'axios';

export const IS_PROD = true;
const IS_QA = false;
export const QA_BLOGS_URL = 'https://stg-blog-api.shwra.net';
export const DEV_BLOGS_URL = 'https://dev-blog-api.shwra.net';
const PROD_BLOGS_URL = 'https://blogs-be.azurewebsites.net';

const BlogURL = IS_QA ? QA_BLOGS_URL : IS_PROD ? PROD_BLOGS_URL : DEV_BLOGS_URL;

export const QA_URL = 'https://stg-platform-api.shwra.net';
export const DEV_URL = 'https://dev-platform-api.shwra.net';
const PROD_URL = 'https://shwra-prod.azurewebsites.net';

export const MusherURL = IS_QA ? "https://shwra-ai-staging-h9ccamdhc2gfetdd.eastus2-01.azurewebsites.net/" : "https://shwra-ai-production-a0hafycdgeb7edg3.eastus2-01.azurewebsites.net/";


export const VoiceNoteUrl = '/api/CustomerApp/PlayAudioFile?fileName=';

export const URL =
  process.env.BASE_URL ?? (IS_QA ? QA_URL : IS_PROD ? PROD_URL : DEV_URL);

export let baseURL = `${URL}/api/`;

export const HUB_URL = URL;
export const HUB_ENV = IS_PROD ? 'Production' : IS_QA ? 'QA' : 'Development';

export const BLOGS_URL = process.env.BLOG_BASE_URL ?? BlogURL;

const axiosInstance = axios.create({
  baseURL,
  withCredentials: false
});


export const requestHandler = async (request: any) => {
  request.headers['Accept-Language'] =
    localStorage.getItem('i18nextLng') === 'en' ? 'en-US' : 'ar-SA';
  return request;
};
axiosInstance.interceptors.request.use((request) => requestHandler(request));
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;


export const IMAGE_URL = `${URL}/api/Files/DownloadFile?fileName=`;

export const Recordingpassword = 'Super@dm!n@116433';

export const Prod_Domain_Url = "https://portal.shwra.sa"

export const Qa_Domain_Url = "https://qa-portal.shwra.sa"

export const Dev_Domain_Url = "https://dev-portal.shwra.sa"
